import {
  validateDateUtil,
  restrictInvalidCharacters,
  selectmenuChangeHandler,
  initializeSelectMenuCreation,
  validateEnteredDate
} from '../utilities/utility';
import { API_REFERENCE } from '../utilities/constant_api';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { formPostJsonResponse, htmlPost, jsonGet } from '../components/ajax';

const existingMonthId = $('#monthdropdown_existing');
const existingdDateId = $('#daydropdown_existing');
const existingYearId = $('#yeardropdown_existing');
let termsAndConditionsAjaxFlag = true;
let validateStepAjaxFlag = true;
let existingUserAjaxFlag = true;
let existingUserGeneralPageAjaxFlag = true;
let validateStepTwoAjaxFlag = true;
let openTermsAndConditionsAjaxFlag = true;
let marketingFormSubmit = null;
const getPatientConsentUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.patientMarketFlow.patientConsentUrl}`;
const getMarketConsentUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.patientMarketFlow.marketingConsentUrl}`;
const termsAndConditionsUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.patientMarketFlow.termsAndConditionUrl}`;
const registerForm = '.registration-form';
const otherReasonsField = '.otherReasons';
const patientSignature = '#patientConsentForm_Signature';
const marketingConsentSign = '#marketingConsentForm_Signature';
const patientRelationship = '#patientConsentForm_relationship';
const reasonPatientId = '#reasonPatient';
const clsPatientAgree = '#patientConsentAgree';
const patientCancelBtn = '.patientBack';

const radioPatient = '#patient';
const clsHidden = 'hidden';
const errorClass = 'error-msg-textbox';
const patientReasonId = '#reasonPatient-button';
const requiredFieldCommon = '.validCommon';
let resendEmailActivationUrl;
let emailFormatFlag = false;
let confirmEmailFormatFlag = false;
let isExistingUser = false;
let bOrderSummaryGuestCheckoutContinueFlag = false;

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread()
  );
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (
    Symbol.iterator in Object(iter) ||
    Object.prototype.toString.call(iter) === '[object Arguments]'
  )
    return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError('Invalid attempt to spread non-iterable instance');
}

var _this = undefined;
/* we have to take certain action on these elements in drop down.
 * So for the time being we are going ahead with this.
 * and hard coding these as per FDD */
$(function() {
  var flowType = $('.registration-create-account-step2').attr('data-flow');
  var cboxOptions = {
    maxWidthLg: '900px',
    maxHeightLg: '800px',
    maxWidthMd: '600px',
    maxHeightMd: '500px',
    maxWidthSm: 'auto',
    maxHeightSm: 'auto'
  };
  let cboxOptionsEmailOverlay = {
    maxWidthLg: '513px',
    maxHeightLg: '585px',
    maxWidthMd: '513px',
    maxHeightMd: '585px',
    maxWidthSm: '360px',
    maxHeightSm: '596px'
  };

  //this code is only for safari
  if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
    $('legend').addClass('safari');
  }

  function printTcDOc(e) {
    e.preventDefault();
    var termsandconditionData = $('#customerAuthPopup')
      .find('.tc-pdf-download-url')
      .remove();
    $('#customerAuthPopup')
      .find('.tc-pdf-version')
      .remove();
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.write('<html><head><title>terms</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h1>Terms and Condtion</h1>');
    mywindow.document.write(
      document.getElementById('customerAuthPopup').innerHTML
    );
    mywindow.document.write('</body></html>');
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    mywindow.close();
    return true;
  }

  function validateDate() {
    var dobValid = false;
    try {
      var rxDobPattern = /^([0][1-9]|[1][0-2])\/([0][1-9]|[1|2][0-9]|[3][0|1])\/([0-9]{4})$/;
    } catch(e) {
      return false;
    }
    if(!($('.customerDob:visible').length)) {
      return true;
    }
    $('.customerDob:visible').each(function(index,dateOfBirth) {
      var dob = $(dateOfBirth).val().match(rxDobPattern);
      if (dob === null) {
        dobValid = false;
      }
      dobValid = true;
    });
    return dobValid;
  }

  if ($(window).width() <= 480) {
    $('.addPhone_insideView').attr('hidden', true);
    $('.addPhone_outsideView').attr('hidden', false);
    $('.back-to-search_normalView').attr('hidden', true);
    $('.back-to-search_mobileView').attr('hidden', false);
  }
  if (location.pathname.indexOf('checkout') == 1) {
    $('.reg-phone-type-label').addClass('ph-type-label phone-type-mt ');
    $('.ph-type-drop-down').addClass('phone-type-width phone-type-mt');
  }else {
    $('.reg-phone-type-label').removeClass('ph-type-label phone-type-mt ');
    $('.ph-type-drop-down').removeClass('phone-type-width phone-type-mt');
  }
  $('.add-phone-link').click(function(e) {
    e.preventDefault();

    if ($('.registration-form-section__input-phone__2').is(':hidden')) {
      $('.registration-form-section__input-phone__2').attr('hidden', false);
    } else if ($('.registration-form-section__input-phone__3').is(':hidden')) {
      $('.registration-form-section__input-phone__3').attr('hidden', false);
      $('.add-phone-link').attr('disabled', true);
      $('.add-phone-link').addClass('disabledLink');
      $('.beforeDisabled').addClass('hidden');
      $('.afterDisabled').removeClass('hidden');
    }
  });

  function displaySmsOptIn() {
    if ($('.phoneTypeDrop_1').val() === 'mobile') {
      $('.sms-optIn-option_1').attr('hidden', false);
    }

    if ($('.phoneTypeDrop_2').val() === 'mobile') {
      $('.sms-optIn-option_2').attr('hidden', false);
    }

    if ($('.phoneTypeDrop_3').val() === 'mobile') {
      $('.sms-optIn-option_3').attr('hidden', false);
    }

    if ($('.phoneTypeDrop_1').val() === 'work') {
      $('.sms-optIn-option_1').attr('hidden', true);
    }

    if (
      $('.phoneTypeDrop_2').val() === 'work' ||
      $('.phoneTypeDrop_2').val() === 'other'
    ) {
      $('.sms-optIn-option_2').attr('hidden', true);
    }

    if (
      $('.phoneTypeDrop_3').val() === 'work' ||
      $('.phoneTypeDrop_3').val() === 'other'
    ) {
      $('.sms-optIn-option_3').attr('hidden', true);
    }
  }

  function validateLastName() {
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var inputLastName = $('.user_lastname').val();

    if (inputLastName === '') {
      $('.error-msg-lastName').attr('hidden', false);
      $('.error-msg-lastInvalidName').attr('hidden', true);
      $('.user_lastname').addClass('error-msg-textbox');
      return false;
    }

    if (!name.test(inputLastName) && inputLastName !== '') {
      $('.error-msg-lastName').attr('hidden', true);
      $('.error-msg-lastInvalidName').attr('hidden', false);
      $('.user_lastname').addClass('error-msg-textbox');
      return false;
    }

    $('.error-msg-lastName').attr('hidden', true);
    $('.error-msg-lastInvalidName').attr('hidden', true);
    $('.user_lastname').removeClass('error-msg-textbox');
    return true;
  }

  function validateFirstName() {
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var inputFirstName = $('#firstName').val();

    if ($('#firstName').val() === '') {
      $('.error-msg-text-firstname').attr('hidden', false);
      $('.error-msg-firstInvalidName').attr('hidden', true);
      $('#firstName').addClass('error-msg-textbox');
      return false;
    }

    if (!name.test(inputFirstName) && inputFirstName !== '') {
      $('.error-msg-text-firstname').attr('hidden', true);
      $('.error-msg-firstInvalidName').attr('hidden', false);
      $('#firstName').addClass('error-msg-textbox');
      return false;
    }

    $('.error-msg-firstInvalidName').attr('hidden', true);
    $('.error-msg-text-firstname').attr('hidden', true);
    $('#firstName').removeClass('error-msg-textbox');
    return true;
  }

  function confirmEmailValidation() {
    var email = $('#newEmail')
      .val()
      .toLowerCase();
    var confirmemail = $('#confirmEmail')
      .val()
      .toLowerCase();

    if (email !== '' && confirmemail !== '' && confirmEmailFormatFlag && emailFormatFlag) {
      if (email !== confirmemail) {
        $('#newEmail').addClass('error-msg-textbox');
        $('#confirmEmail').addClass('error-msg-textbox');
        $('.notvalid').attr('hidden', false);
        $('#registration-form .confirmemailtxtvalid').attr('hidden', true);
        return false;
      }

      $('.confirmemailtxtvalid').attr('hidden', true);
      $('.emailtxtvalid').attr('hidden', true);
      $('.notvalid').attr('hidden', true);
      $('.emailtxt').attr('hidden', true);
      $('.confirmemailtxt').attr('hidden', true);
      $('#newEmail').removeClass('error-msg-textbox');
      $('#confirmEmail').removeClass('error-msg-textbox');
      return true;
    }
  }

  function initRedirectUrlCheck() {
    let searchParams = new URLSearchParams(window.location.search);
    let replaceUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAccount.newRegistrationRedirect}`;
    if (searchParams.get('preRegistered')) {
      $('#acct-reg-purchase-from-ep-before-yes').click();
      window.history.replaceState(null, '', replaceUrl);
    }
  }

  $(document).ready(function() {
    $.urlParam = function(name) {
      var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
        window.location.href
      );

      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    };

    var param = $.urlParam('rc');
    if (param != null) {
      window.sessionStorage.setItem('referralCode', param);
    }
    
    if ($('.radio_input_no').is(':checked')) {
      $('.existingRegistration').removeAttr('hidden');
      $('.existingRegistration')
        .find("input[type ='text']")
        .val('');
      $('.existingRegistration').find($('.existing_user_select ').val(''));
      $('.existingRegistration')
        .find($('.register_btn '))
        .prop('disabled', true);
      $('.newRegistration').attr('hidden', true);
    }
    $('.required-val').keyup(function() {
      var empty = false;
      $('.required-val').each(function() {
        if ($(this).val() !== null && $(this).val().length == 0) {
          empty = true;
        }
      });

      if (empty) {
        $('.registration_button').attr('disabled', 'disabled');
      } else {
        $('.registration_button').attr('disabled', false);
        $('.registration_button').attr('tabindex', 0);
      }
    });
    $(
      '#genderDrop,#phoneTypeDrop_1,#phoneTypeDrop_2,#phoneTypeDrop_3,#monthdropdown,#daydropdown,#yeardropdown,#monthdropdown_existing,#daydropdown_existing,#yeardropdown_existing,#facility-statedown_existing,#facility-state,#reg-ref-dropdown,#facilityState'
    ).selectmenu();
    selectmenuAccessibilityCompliance();
    $('#monthdropdown_existing-button').attr('aria-required', true);
    initRedirectUrlCheck();
  });

  function enableNextButtonFunction(e) {
    var empty = false;
    if (location.pathname.indexOf('checkout') == -1 && location.pathname.indexOf('my-account-home') == -1) {
      if ($('#smsOptIn').is(':checked')) {
        empty = true;        
        $('#phone-no-sms-enroll').each(function() {
            if($('.sms-input').hasClass('error-msg-textbox') || $('.sms-input') === null || $('.sms-input').val().length == 0 || $('.sms-input').val().length < 12) {
              empty = true;
              if($('.sms-input').val().length > 0 && $('.sms-input').val().length < 12){
                $(this).siblings('.error-msg-text').removeClass('hidden');
              }           
            } else {
              empty = false;
              $(this).siblings('.error-msg-text').addClass('hidden');
            }
        });
      } else {
        $('.sms-input').val('').removeClass('error-msg-textbox');
        e.stopPropagation(); 
      }
    };
    $('.required-val').each(function() {
      if (
        ($(this).val() !== null && $(this).val().trim() === '') ||
        $(this).val() === null
      ) {
        empty = true;
      }
    });
    if($('.newRegistration').find('.registration--form-dob').is(":visible") && !validateEnteredDate($('.newRegistration').find('.registration--form-dob').val())){
      empty = true;
    }
    if (empty) {
      $('.registration_button').attr('disabled', 'disabled');
    } else {
      $('.registration_button').attr('disabled', false);
      $('.registration_button').attr('tabindex', 0);
    }
  }

  function inValidFormInput(e) {
    $(e.target).removeClass('error-msg-textbox');
    let patternMismatchEle = $(e.target)
      .parent()
      .find('.pattern-mismatch-text');
    let valueMissingEle = $(e.target)
      .parent()
      .find('.value-missing-text');
    let notValidElemenet = $(e.target)
      .parent()
      .find('.notvalid');
    let tollFreePatternMismatchEle = $(e.target)
      .parent()
      .find('.pattern-mismatch-toll-text');
    //HTML5 validation does not work with select in IE11 so fix done for the same
    if (e.target.type.indexOf('select') === -1) {
      //validity.valid does not work in IE11 so replaced the code for the same
      if (e.target.validity.valueMissing || e.target.value.trim() === '' || e.target.validity.patternMismatch) {
        e.preventDefault();
        if (e.target.validity.patternMismatch) {
          valueMissingEle.attr('hidden', true);

          if (
            $(e.target).hasClass('new-account-phone') &&
            e.target.value.length === 12
          ) {
            patternMismatchEle.attr('hidden', true);
            tollFreePatternMismatchEle.attr('hidden', false);
            $(e.target).addClass('error-msg-textbox');
          } else {
            patternMismatchEle.attr('hidden', false);
            tollFreePatternMismatchEle.attr('hidden', true);
          }
        } else {
          valueMissingEle.attr('hidden', false);
          patternMismatchEle.attr('hidden', true);
          notValidElemenet.attr('hidden', true);
          tollFreePatternMismatchEle.attr('hidden', true);
        }
        if (
          !(
            $(e.target).hasClass('new-account-phone') &&
            e.target.value.length === 12
          )
        ) {
          $(e.target).addClass('error-msg-textbox');
        }
        if (
          !(
            $(e.target).hasClass('sms-input') &&
            e.target.value.length === 12
          )
        ) {
          $(e.target).addClass('error-msg-textbox');
        }
        if($(e.target).hasClass('new-account-dob') || $(e.target).hasClass('existing-account-dob')) {
          if(e.target.value.length !==10 || e.target.value.match("/^(([0][1-9]|[1][0-2]))\/(([0][1-9])|([1][0-9])|([2][0-9])|([3][0-1]))\/([0-9]{4})$/")) {
            patternMismatchEle.attr('hidden', false);
          }
        }
        return false;
      } else {
        if (patternMismatchEle.length > 0) {
          patternMismatchEle.attr('hidden', true);
        }
        if (valueMissingEle.length > 0) {
          valueMissingEle.attr('hidden', true);
        }
        return true;
      }
    } else {
      var selectVal = $(e.target).val().trim();
      if (selectVal !== '' && selectVal !== null) {
        valueMissingEle.attr('hidden', true);
        $(e.target)
          .parents('.dropdown')
          .find('.ui-selectmenu-button')
          .removeClass('error-msg-textbox');
      } else {
        if (
          $(e.target).attr('id') !== 'phoneTypeDrop_2' &&
          $(e.target).attr('id') !== 'phoneTypeDrop_3'
        ) {
          valueMissingEle.attr('hidden', false);
          $(e.target)
            .parents('.dropdown')
            .find('.ui-selectmenu-button')
            .addClass('error-msg-textbox');
        }
      }
      return true;
    }
  }

  function validatePhone(e) {
    var phoneNumberValid = false;
    var rxPhonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    $('.demographicsCustomerPhoneNumber:visible').each(function(
      index,
      phoneNumber
    ) {
      var phone = $(phoneNumber)
        .val()
        .match(rxPhonePattern);

      if (phone === null) {
        phoneNumberValid = false;
      }
      phoneNumberValid = true;
    });

    return phoneNumberValid;
  }

  function validateStep(e) {
    e.preventDefault();
    if (!validateDate() || !confirmEmailValidation() || !validatePhone()) {
      return false;
    }

    var submitNewRegistrationUrl = null;
    if (location.pathname.indexOf('checkout') > 0) {
      submitNewRegistrationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAccount.registration}`;
    } else {
      submitNewRegistrationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.newRegistration.newCustomerRegistration}`;
    }
    if ($('#smsOptIn').is(':checked')) {
      $('#save-sms-enroll').click();
    }
    let formDataObject = getFormData($(this));
    let splitDate = formDataObject['customerDateOfBirth'].split("/");
    //$(this).find('input[name=dateOfBirth]').val(formDataObject['customerDateOfBirth']);
    $(this).find('input[name=monthOfBirth]').val(splitDate[0]);
    $(this).find('input[name=dayOfBirth]').val(splitDate[1]);
    $(this).find('input[name=yearOfBirth]').val(splitDate[2]);
    $(this).find('input[name=dateOfBirth]').val(splitDate[2] +'-'+splitDate[0]+'-'+splitDate[1]);
    var $form = $(this).find("input[name!=customerDateOfBirth]").serialize();   
    $('#cah-new-message-block').empty();
    if (!validateStepAjaxFlag) return false;
    validateStepAjaxFlag = false;
    formPostJsonResponse(submitNewRegistrationUrl, $form)
      .then(data => {
        validateStepAjaxFlag = true;
        $('#customer-creation-error-msg').addClass('hidden');
        if (data == 'FAIL') {
          $('#customer-creation-error-msg').removeClass('hidden');
          return;
        }

        if (data === 'SUCCESS') {
          if (location.pathname.indexOf('preregister') === -1) {
            validateStep2(e);
            $(window).scrollTop(0);
          } else {
            $('.dob-msg-required').attr('hidden', true);
            $('.newRegistration_step1').hide();
            $('.newRegistration_step2').removeClass('hidden');
            $('.register-user').attr('disabled', false);
            $('.newRegistration_step2').show('fast', function() {
              $(window).scrollTop(0);
            });
            if (location.pathname.indexOf('checkout') > 0) {
              $('.checkoutAccountFlow').each(function() {
                $(this)
                  .addClass('pl-0')
                  .removeClass('pr-0');
              });
              $('.checkoutShow').addClass('pr-3');
            }
          }
        } else if (data === 'CustomerExist') {
          $('.noRecordDiv').attr('hidden', false);
          $(window).scrollTop(0);
        }else if(data === 'CustomerExistsInRGH'){
          showRGHforExistingAccountModal();
        }
      })
      .catch(() => {
        validateStepAjaxFlag = true;
      });
    return true;
  }

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  function existingUser(e) {
    e.preventDefault();
    if (!validateDate()) {
      return false;
    }

    var submitNewRegistrationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.newRegistration.existingCustomerRegistration}`;
    let formDataObject = getFormData($(this));

    let splitDate = formDataObject['customerDateOfBirth'].split("/");
    //$(this).find('input[name=dateOfBirth]').val(formDataObject['customerDateOfBirth']);
    $(this).find('input[name=monthOfBirth]').val(splitDate[0]);
    $(this).find('input[name=dayOfBirth]').val(splitDate[1]);
    $(this).find('input[name=yearOfBirth]').val(splitDate[2]);
    //$(this).find('input[name=customerDateOfBirth]').remove();
    $(this).find('input[name=dateOfBirth]').val(splitDate[2] +'-'+splitDate[0]+'-'+splitDate[1]);
    $(this).find('input[name=policyNumber]').val(formDataObject['accountInfoRadio']== 'policyNumber' ? formDataObject['accountOrPolicyNumber'] : '');
    $(this).find('input[name=iconCustomerID]').val(formDataObject['accountInfoRadio']== 'accountNumber' ? formDataObject['accountOrPolicyNumber'] : '');
    var $form = $(this).find("input[name!=customerDateOfBirth]").serialize();
    $('.global-error-message-container').addClass('hidden');
    $('#cah-new-message-block').empty();
    if (!existingUserAjaxFlag) return false;
    existingUserAjaxFlag = false;
    formPostJsonResponse(submitNewRegistrationUrl, $form)
      .then(response => {
        existingUserAjaxFlag = true;
        const data = $.extend({}, response);
        if (data.error || data.warning) {
          switch(data.ERROR_TYPE){
			  case "EXISTING_ACCOUNT":	
			  	  $('#cah-new-message-block').html($('#existingaccount-warning-msg').html()); 	 
			  	  break;
			  case "ACCOUNT_NOT_FOUND": 			
			  	  $('#acct-reg-purchase-from-ep-before-no').trigger('click');
			  	  $('#cah-new-message-block').html($('#existingaccountnotfound-error-msg').html());
			  	  break;
        case "MULTIPLE_ACCOUNT_EXCEPTION":  
			  	  $('#acct-reg-purchase-from-ep-before-no').trigger('click');  
			  	  $('#cah-new-message-block').html($('#multipleaccountfound-error-msg').html());
			  	  break;            
			  default: 
			  	  $('.global-error-message-container .generic-error-text').text(
		            data.error
		          );
          		  $('.global-error-message-container').removeClass('hidden');
          		  break;
				  
		  }
                   
          if (data.error == $('#no-customer-error-msg').text()) {
            window.open($('#legacyRegistrationUrl').val(), '_self');
          }
          $('#nextexistregister').attr('disabled', 'disabled');
          $(window).scrollTop(0);
        }else if(data['CustomerExistsInRGH']){
          showRGHforExistingAccountModal();
        }else {
          var $registrationStep2 = $('.existingUserRegistration_step2');
          var $registrationStepForm = $registrationStep2.find('form')[0];
          var firstPhoneNumber =
            data.firstPhoneNumber &&
            data.firstPhoneNumber.replace(
              /^(\d{3})(\d{3})(\d{4}).*/,
              '$1.$2.$3'
            );
          if (
            data.addressLine1 === '' &&
            data.addressLine2 === '' &&
            data.city === '' &&
            data.state === '' &&
            data.zipCode === ''
          ) {
            $('.addressNotExistDiv').removeClass('hidden');
          }
          $('.record-unsuccessful').addClass('hidden');
          $('.js-registration-firstname').html(data.firstName);
          $('.js-registration-input-firstname').val(data.firstName);
          $('.js-registration-lastname').html(data.lastName);
          $('.js-registration-input-lastname').val(data.lastName);
          $('.js-registration-dateofbirth').html(data.dateOfBirth);
          $('.js-registration-input-dateofbirth').val(data.dateOfBirth);
          $('.js-registration-accountnumber').html(data.accountNumber);
          $('.js-registration-input-accountnumber').val(data.accountNumber);
          $('.js-registration-insurance').html(data.memberId);
          $('.js-registration-address1').html(data.addressLine1);
          $('.js-registration-address2').html(data.addressLine2);
          $('.js-registration-city').html(data.city);
          $('.js-registration-state').html(data.state);
          $('.js-registration-zipcode').html(data.zipCode);
          $('.js-registration-input-phonenumber').val(firstPhoneNumber);
          if (isEmail(data.email)) {
            $('.js-registration-input-email').val(data.email);
          } else {
            $('.existingUser_generalInfo_form')
              .find('.js-registration-input-email')
              .val('');
          }
          $('input[name=existingGender][value=' + data.gender + ']').prop(
            'checked',
            true
          );
          $('.dob-msg-required').attr('hidden', true);
          $('.newRegistration_step1').hide();
          $registrationStep2.removeClass('hidden');
          if (location.pathname.indexOf('checkout') > 0) {
            $('.checkoutExistingUserPanel')
              .removeClass('col-md-9')
              .addClass('col-md-12');
            $('.checkoutflowPreScreen').addClass('preRegisterCheckout');
            $('.createAccount').addClass('preRefisterInfoSection');
            $('.generalInformation').addClass('preRefisterInfoSection');
            $('.primaryAddress').addClass('preRefisterInfoSection');
          }
          if (
            $registrationStepForm !== undefined &&
            !$registrationStepForm.checkValidity()
          ) {
            $registrationStep2.find('.next-btn').attr('disabled', true);
          }
          $registrationStep2.show('fast', function() {
            $(window).scrollTop($registrationStep2.offset().top);
          });
        }
      })
      .catch(() => {
        existingUserAjaxFlag = true;
      });

    return true;
  }

  function existingUserGeneralPage(e) {
    e.preventDefault();
    if (!validateDate()) {
      return false;
    }

    var $newRegistrationStep2 = $('.newRegistration_step2');
    $('.newRegistration_step2').find('.step2_form').length &&
      $('.newRegistration_step2')
        .find('.step2_form')[0]
        .reset();
    var submitNewRegistrationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.newRegistration.existingCustomerRegistrationStep2}`;

    var $form = $(this).serialize();
    if (!existingUserGeneralPageAjaxFlag) return false;
    existingUserGeneralPageAjaxFlag = false;
    formPostJsonResponse(submitNewRegistrationUrl, $form)
      .then(data => {
        existingUserGeneralPageAjaxFlag = true;
        if (data === 'SUCCESS') {
          if (location.pathname.indexOf('preregister') === -1) {
            validateStep2(e);
            $(window).scrollTop(0);
          } else {
            $('.dob-msg-required').attr('hidden', true);
            $('.existingUserRegistration_step2').hide();
            $newRegistrationStep2.removeClass('hidden');
            if (location.pathname.indexOf('checkout') > 0) {
              $('.checkoutAccountFlow').each(function() {
                $(this)
                  .addClass('pl-0')
                  .removeClass('pr-0');
              });
              $('.checkoutShow').addClass('pr-3');
            }
            $newRegistrationStep2.show('fast', function() {
              $(window).scrollTop(0);
              //$('#referral_div').remove();
              $('.hiddencurrentCallType').val('existingUser');
            });
          }
        } else if (data === 'CustomerExist') {
          $('.customerExistDiv').removeClass('hidden');
          $(window).scrollTop(0);
        }
      })
      .catch(() => {
        existingUserGeneralPageAjaxFlag = true;
      });

    return true;
  }
  function validatePCSignature(event) {
    let signCharactersCount = 0;
    signCharactersCount = event.target.value.trim().length;
    if (
      $("input[name='usertype']:checked").val() === 'patient' &&
      signCharactersCount >= 2
    ) {
      $('#patientConsentContinue').removeAttr('disabled');
    } else if (
      $("input[name='usertype']:checked").val() === 'representative' &&
      signCharactersCount >= 2 &&
      $(patientRelationship).val().trim().length > 0 &&
      $(reasonPatientId).val() !== '' &&
      $(reasonPatientId).val() !== null
    ) {
      $('#patientConsentContinue').removeAttr('disabled');
    } else {
      $('#patientConsentContinue').attr('disabled', 'disabled');
      $(this).removeClass('success-msg-textbox');
    }
  }
  function validatePCRelationship(event) {
    var isValid = true;
    if (
      $(patientSignature).val().trim() === '' ||
      $(patientSignature).val().trim() < 2 ||
      $(patientRelationship).val().trim() === '' ||
      $(reasonPatientId).val() === '' ||
      $(reasonPatientId).val() === null
    ) {
      isValid = false;
    }
    isValid
      ? $('#patientConsentContinue').removeAttr('disabled')
      : $('#patientConsentContinue').attr('disabled', 'disabled');
  }
  function showSignValidateSuccess(event){
    if(event.target.value.trim().length >= 2){
      $(this).removeClass('error-msg-textbox');
      $(this).addClass('success-msg-textbox');
    }else{
      $(this).removeClass('success-msg-textbox');
    }
  }
  function showMarketingConsent(){
    $('.marketing-consent-block').show();
    $('.patient-consent-block').hide();
    $(window).scrollTop(0);
    $('.setup-progress-steps #line-two').addClass('filled-1-of-3');
  }
  function showTermsandConditions(){
    $('.marketing-consent-block').hide();
    $('.terms-conditions-block').show();
     $(window).scrollTop(0);
     $('.setup-progress-steps #line-two').removeClass('filled-1-of-3').addClass('filled-2-of-3');
  }

  function saveTermsAndConditions() {	  
    if (
      $(this).hasClass('combined-consent-agree-btn') ||
      $(this).hasClass('preregister-combined-consent-agree-btn')
    ) {
      if (!validateConsentFields()) {
        $('.error-msg-textbox:first').focus();
        return false;
      }
    }

    let submitTermsAndConditionUrl = null;
    let marketingConsent = false;
    let marketingConsentVersion = $('#marketingconsent-version-number').val();
    const getPatientSignVal = $(patientSignature).val();
    const getMarketConsentPatientSign = $(marketingConsentSign).val();

    if (
      $(marketingConsentSign).val() != null &&
      $(marketingConsentSign).val() != ''
    ) {
      marketingConsent = true;
    }
    const getRelationshipVal = $(patientRelationship).val();
    const getReasonVal = $(reasonPatientId).val();
    const getOtherReasonVal = $(otherReasonsField).val();
    const getRadioSelected = $("input[name='usertype']:checked").val();
    const getDate = $('#dateSigned').val();
    const getCurrentDate = $('#marketDateSigned').val();
    const isCheckboxChecked = $(clsPatientAgree).prop('checked');
    if (location.pathname.indexOf('checkout') > -1) {
      submitTermsAndConditionUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAccount.createUser}`;
    } else {
      submitTermsAndConditionUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.newRegistration.finalCreateUser}`;
    }
    var firstForm = $(registerForm).serialize();
    var secondForm = $('.step2_form').serialize();
    var lastForm = $('.existingUser_generalInfo_form').serialize(); 
    var pdfVersionNo = $('#pdf-version-number').val();
    let referralCode = window.sessionStorage.getItem('referralCode');
    
    if (!termsAndConditionsAjaxFlag) return false;
    termsAndConditionsAjaxFlag = false;
    let formData = `${firstForm}&${secondForm}&${lastForm}&pdfVersion=${pdfVersionNo}&patientSignature=${getPatientSignVal}&representativeRelationship=${getRelationshipVal}&representativeReason=${getReasonVal}&representativeOtherReason=${getOtherReasonVal}&patientSelected=${getRadioSelected}&patientConsent=${isCheckboxChecked}&dateSigned=${getDate}&marketingConsent=${marketingConsent}&marketingConsentVersion=${marketingConsentVersion}&marketDateSigned=${getCurrentDate}&marketingConsentSign=${getMarketConsentPatientSign}`;
    if (referralCode != null) {
      formData = `${formData}&referralCode=${referralCode}`;
    }
    htmlPost(submitTermsAndConditionUrl, formData)
      .then(data => {
		let termsConditionData = JSON.parse(data);
        termsAndConditionsAjaxFlag = true;
        
        if (termsConditionData.STATUS === 'SUCCESS') {
           if (location.pathname.indexOf('checkout') > -1 && !isExistingUser){
             window.location.href = API_REFERENCE.checkoutAccount.accountInformation;
           }
          else if (location.pathname.indexOf('preregister') > -1) {
            window.location.href = '/';
          } else {
            ACC.colorbox.open('', {
              escKey: false,
              overlayClose: false,
              closeButton: false,
              html: $('#email-notification-overlay').html(),
              onLoad: $('#cboxOverlay').css('position', 'fixed'),
              width: checkWidthEmailOverlay(),
              height: checkHeightEmailOverlay(),
              className: 'email-notification-overlay-main'
            });
            startCountDown();
            resendEmailActivationUrl = termsConditionData.resendOktaActivationLink;
            $('.oktaActivationTestLink').attr(
              'href',
              termsConditionData.oktaActivationTestLink
            );
          }
        } else if (termsConditionData.STATUS === 'ExistingUser') {
          $('.customerExistDiv').removeClass('hidden');
          $(window).scrollTop(0);
        } else {
          $('.oktaErrorDiv').attr('hidden', false);
        }
      })
      .catch(() => {
        termsAndConditionsAjaxFlag = true;
      });
    return true;
  }

  function checkDate() {
    var ddlDay = $('#daydropdown').val();
    var ddlMonth = $('#monthdropdown').val();
    var ddlYear = $('#yeardropdown').val();

    if (ddlDay === '' || ddlDay === null) {
      $('.date-msg-required').attr('hidden', false);
      $('#daydropdown').addClass('error-msg-textbox');
    } else {
      $('.date-msg-required').attr('hidden', true);
      $('#daydropdown').removeClass('error-msg-textbox');
    }

    if (ddlMonth === '' || ddlMonth === null) {
      $('.month-msg-required').attr('hidden', false);
      $('#monthdropdown').addClass('error-msg-textbox');
    } else {
      $('.month-msg-required').attr('hidden', true);
      $('#monthdropdown').removeClass('error-msg-textbox');
    }

    if (ddlYear === '' || ddlYear === null) {
      $('.year-msg-required').attr('hidden', false);
      $('#yeardropdown').addClass('error-msg-textbox');
    } else {
      $('.year-msg-required').attr('hidden', true);
      $('#yeardropdown').removeClass('error-msg-textbox');
    }
  }

  function genderValue() {
    var genderVal = $('#genderDrop').val();

    if (genderVal === '') {
      $('.genderReq').attr('hidden', false);
      $('#genderDrop').addClass('error-msg-textbox');
      return false;
    }

    $('#genderDrop').removeClass('error-msg-textbox');
    $('.genderReq').attr('hidden', true);
    return true;
  }

  function phoneType() {
    var phoneVal = $('#phoneTypeDrop_1').val();

    if (phoneVal === '') {
      $('.phoneType-error').attr('hidden', false);
      $('#phoneTypeDrop_1').addClass('error-msg-textbox');
      return false;
    }

    $('#phoneTypeDrop_1').removeClass('error-msg-textbox');
    $('.phoneType-error').attr('hidden', true);
    return true;
  }

  function validateInput(e) {
    $(this)
      .next()
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');

    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  var elementsRegisteration = document.getElementsByClassName(
    'registration-form-section__input-element'
  );
  $.each(elementsRegisteration, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidFormInput);
  });

  function validateFacilityStateSelectmenu(e) {
    $(e.target)
      .removeClass('error-msg-textbox')
      .parent()
      .find('.error-msg-text')
      .attr('hidden', true);
    $(e.target)
      .next()
      .removeClass('error-msg-textbox');
  }

  function stepSwitch() {
	$('#cah-new-message-block').empty();
    $('.error-invalidDate').attr('hidden', true);
    $('.noRecordDiv').attr('hidden', true);
    $('.global-error-message-container').addClass('hidden');
    var inputValue = $(this).attr('value');

    if (inputValue === 'yes') {
      isExistingUser = true;
      $('.existingRegistration').attr('hidden', false);
      $('.existingRegistration').find($("input[type ='text']").val(''));
      $('.existingRegistration').find($('.existing_user_select ').val(''));
      $('.existingRegistration')
        .find($('.register_btn '))
        .prop('disabled', true);
      $('.newRegistration').attr('hidden', true);
    }

    if (inputValue === 'no') {
      isExistingUser = false
      $('.newRegistration').attr('hidden', false);
      $('.existingRegistration').attr('hidden', true);
    }
  }
  $('#facilityState').on('selectmenuchange', validateFacilityStateSelectmenu);
  $('.phoneTypeDrop_1').on('selectmenuchange', displaySmsOptIn);
  $('.phoneTypeDrop_2').on('selectmenuchange', displaySmsOptIn);
  $('.phoneTypeDrop_3').on('selectmenuchange', displaySmsOptIn);
  $('.radio_input').on('change', stepSwitch);
  $('[data-toggle="tooltip"]').tooltip();
  $(registerForm).on('submit', validateStep);
  $('.registration-form-section__input-element').on(
    'input selectmenuchange',
    inValidFormInput
  );
  $('#newEmail').on('change', validateEmailComplexity);
  $('.confirmEmail').on('change', validateEmailComplexity);
  $('#newEmail').on('change', confirmEmailValidation);
  $('.confirmEmail').on('change', confirmEmailValidation);
  //$('.confirmEmail').on('blur', inValidFormInput);

  function validateLastNameExisting() {
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var inputName = $('.existingUser_lastname').val();

    if ($('.existingUser_lastname').val() === '') {
      $('.error-msg-lastName').attr('hidden', false);
      $('.error-msg-text-invalidName').attr('hidden', true);
      $('.existingUser_lastname').addClass('error-msg-textbox');
    }

    if ($('.existingUser_lastname').val() !== '') {
      if (!name.test(inputName)) {
        $('.error-msg-lastName').attr('hidden', true);
        $('.error-msg-text-invalidName').attr('hidden', false);
        $('.existingUser_lastname').addClass('error-msg-textbox');
      } else {
        $('.error-msg-lastName').attr('hidden', true);
        $('.error-msg-text-invalidName').attr('hidden', true);
        $('.existingUser_lastname').removeClass('error-msg-textbox');
      }
    }

    return true;
  }

  function validateUserInput(e) {
    e.preventDefault();

    if (!validateDate()) {
      return false;
    }

    if (!validateLastNameExisting());

    return true;
  }

  var elements1 = document.getElementsByClassName('existingUser_form__input');
  $.each(elements1, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidFormInput);
  });
  $('.existingUser_form').on('submit', validateUserInput);
  $('.existingUser_lastname').on('input', validateLastNameExisting); // New registration Step-2 and facility-search

  var formElement = $('.step2_form');

  function resetModal() {
    $('.newFacilityModal').trigger('reset');
    var invalidFields = $('.newFacilityModal').find('.error-msg-textbox');
    var errorMessages = $('.newFacilityModal').find('.error-msg-text');

    _toConsumableArray(errorMessages).forEach(function(msg) {
      $(msg).attr('hidden', true);
    });

    _toConsumableArray(invalidFields).forEach(function(field) {
      $(field).removeClass('error-msg-textbox');
    });
  }

  function newFacilityValidate(e) {
    e.preventDefault();
  }

  var elements = document.getElementsByClassName('newFacilityInput');
  $.each(elements, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidFormInput);
  });

   $('#facility-state option:first-child').attr('disabled', 'disabled');

  function backToRegistrationStep1() {
    $('.newRegistration_step1').show();
    $('.newRegistration_step2').hide();
    $('.existingUserRegistration_step2').hide();
    $('.facility-search-section').attr('hidden', true);
  }

  function validateInputStep2(e) {
    e.preventDefault();
    $('.error-securityAnswer').attr('hidden', true);
    $('.error-msg-password').attr('hidden', true);
    $(this)
      .next()
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');

    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function confirmPasswordValidation() {
    $('.showhide-field').attr('hidden', false);
    $('.error-msg-text-password').attr('hidden', true);
    $('.error-msg-password-noMatch').attr('hidden', true);
    $('.passwordFieldValidation').removeClass('error-msg-textbox');
    $('.error-msg-password-invalid').attr('hidden', true);
    var password = $('.passwordField').val();
    var confirmPassword = $('.confirmPasswordField').val();
    let userId;
    if ($('#acct-reg-purchase-from-ep-before-no').is(':checked')) {
      userId = $('#newEmail').val();
    } else {
      userId =
        $('.existingUser_generalInfo_form #hiddenemail').val() || undefined;
    }

    if (password !== confirmPassword) {
      $('.confirmPasswordField').addClass('error-msg-textbox');
      $('.error-msg-password-noMatch').attr('hidden', false);
      return false;
    } else if (password.indexOf(userId) !== -1) {
      $('.passwordField').addClass('error-msg-textbox');
      $('.confirmPasswordField').addClass('error-msg-textbox');
      $('.error-msg-password-invalid').attr('hidden', false);
      return false;
    }

    if (password === confirmPassword) {
      $('.error-msg-password-noMatch').attr('hidden', true);
    }

    return true;
  }

  function checkWidth() {
    if (window.innerWidth >= 992) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  }

  function checkHeight() {
    if (window.innerHeight >= 992) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  }

  function checkWidthEmailOverlay() {
    if (window.innerWidth >= 992) {
      return cboxOptionsEmailOverlay.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      return cboxOptionsEmailOverlay.maxWidthMd;
    } else {
      return cboxOptionsEmailOverlay.maxWidthSm;
    }
  }

  function checkHeightEmailOverlay() {
    if (window.innerHeight >= 992) {
      return cboxOptionsEmailOverlay.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
      return cboxOptionsEmailOverlay.maxHeightMd;
    } else {
      return cboxOptionsEmailOverlay.maxHeightSm;
    }
  }

  function enableRegister() {    
      if ($('#hiddenemail').val() !== 'null') {
        if (
          $('.passwordField').val() !== '' &&
          $('.confirmPasswordField').val() !== '') {
          $('.register-user').attr('disabled', false);
        } else {
          $('.register-user').attr('disabled', true);
        }
      } else if ($('#hiddencurrentCallType').val() !== 'null') {
        if (
          $('.passwordField').val() !== '' &&
          $('.confirmPasswordField').val() !== '') {
          $('.register-user').attr('disabled', false);
        } else {
          $('.register-user').attr('disabled', true);
        }
      } else {
    	  $('.register-user').attr('disabled', true);
      }    
  }

  function validateStep2(e) {
    e.preventDefault();    
    if (
      !confirmPasswordValidation() && !validatePasswordComplexity() &&
      location.pathname.indexOf('preregister') > -1
    ) {
      return false;
    }

    var currentForm = $('.step2_form').serialize();
    var prevForm = $(registerForm).serialize();
    var secondForm = $('.existingUser_generalInfo_form').serialize();
    var patientConsentData = null;         
    if (!validateStepTwoAjaxFlag) return false;
    validateStepTwoAjaxFlag = false;
    const formData = `${prevForm}&${currentForm}&${secondForm}`;
    htmlPost(getPatientConsentUrl, formData)
      .then(patientResponse => { 	  
        if (location.pathname.indexOf('checkout') > -1) {
          validateStepTwoAjaxFlag = true;
          patientConsentData = ACC.sanitizer.sanitizeHtmlDeeply(patientResponse);
          $('.registration_wrapper').hide();
          $('.registration_container').append(patientConsentData);
          $('#reasonPatient').selectmenu();
          $('#marketingconsent-version-number').val(
            $('.marketing-consent-info .tc-pdf-version').text()
          );
        } else {
          const passwordForm = $('.step2_form').serialize();
          const regForm = $('.registration-form').serialize();
          const existingForm = $('.existingUser_generalInfo_form').serialize();
          let marketingConsentData = null;       
          $.ajax({
            type: 'POST',
            url: getMarketConsentUrl,
            data: regForm + '&' + passwordForm + '&' + existingForm,
            success: function(marketingResponse) {
              var currentFormTerm = $('.step2_form').serialize();
              var prevFormTerm = $(registerForm).serialize();
              var secondFormTerm = $(
                '.existingUser_generalInfo_form'
              ).serialize();
              var termsAndConditionData = null;
              const formDataTerms = `${prevFormTerm}&${currentFormTerm}&${secondFormTerm}`;
              htmlPost(termsAndConditionsUrl, formDataTerms)
                .then(data => {
                  validateStepTwoAjaxFlag = true;
                  patientConsentData = ACC.sanitizer.sanitizeHtmlDeeply(patientResponse);
                  marketingConsentData = ACC.sanitizer.sanitizeHtmlDeeply(marketingResponse);
                  $('.registration_wrapper').hide();
                  $('.patient-consent-block').append(patientConsentData);
                  $('.marketing-consent-block').append(marketingConsentData);
                  //$('.registration_container').append(patientConsentData);
                  //$('.registration_container').append(marketingConsentData);

                  $('#reasonPatient').selectmenu();
                  $('#marketingconsent-version-number').val(
                    $('.marketing-consent-info .tc-pdf-version').text()
                  );
                  termsAndConditionData = ACC.sanitizer.sanitizeHtmlDeeply(data);//$.extend({}, data);
                  $('.terms-conditions-block')
                    .append(termsAndConditionData)
                    .promise()
                    .done(function() {
                      appendPdfUrl($('.tc-pdf-download-url').text());
                      /** OFF scroll event, in case when user close and open COLORBOX multiple time, then multiple scroll event should not bind **/
                      $('#printDoc')
                        .off('scroll', enableTermAndConditionButton)
                        .on('scroll', enableTermAndConditionButton);
                    });
                    $('#patientConsentAgree').attr('checked','checked');
                    $('.patientConsent_content_agree').addClass('hidden');
                    $(document).on('keyup', '#patientConsentForm_Signature', validatePCSignature);
                    $(document).on('keyup blur','#patientConsentForm_relationship',validatePCRelationship);
                    $(document).on('selectmenuchange','#reasonPatient',validatePCRelationship);
                    $(document).on('blur', '#patientConsentForm_Signature', showSignValidateSuccess);
                    $('.marketing-consent-block').hide();  
                    $('.terms-conditions-block').hide();
                    $('.setup-progress-steps #step-one').removeClass('outlined').addClass('filled');
                    $('.setup-progress-steps #line-one').addClass('filled-full');
                    $('.setup-progress-steps #step-two').addClass('outlined');

                  $('.registration-container__account').addClass(
                    'combined-consent-style'
                  );
                  $('.pre_registration_container').addClass(
                    'combined-preregister-consent-style'
                  );
                  $('.patientConsent_form_buttonGroup').addClass('hidden');
                  $('.marketing-consent-footer').addClass('hidden');
                  $('.patientConsent_title').replaceWith(
                    '<h3 class="patientConsent_title mb-2 combined-patientConsent_title">' +
                      $('.patientConsent_title').html() +
                      '</h3>'
                  );
                  $('.marketing-consent-header').replaceWith(
                    '<h3 class="marketing-consent-header combined-marketing-consent-header">' +
                      $('.marketing-consent-header').html() +
                      '</h3>'
                  );
                  $('.terms_conditions__header').replaceWith(
                    '<h3 class="modal-title terms_conditions__header combined-terms_conditions__header">Terms and Conditions</h3>'
                  );

                  $(window).scrollTop(0);
                  if (location.pathname.indexOf('preregister') === -1) {
                    $('.termsAndCondition__Savebutton').addClass(
                      'combined-consent-agree-btn'
                    );
                  } else {
                    $('.termsAndCondition__Savebutton').addClass(
                      'preregister-combined-consent-agree-btn'
                    );
                  }

                  /*Patient consent css*/
                  $('.patientConsent_document').removeClass('p-lg-0 p-2');
                  $('.patientConsent_document').addClass(
                    'combined-patient-consent'
                  );
                  let patientConsentCheckbox = $(
                    '.patientConsent_content_agree'
                  );
                  patientConsentCheckbox.addClass(
                    'combined-patientConsent_content_agree'
                  );
                  $('.combined-patient-consent').addClass('scrollbar');

                  /*Marketing consent css*/
                  $('.marketing-consent-container').addClass(
                    'combined-marketing-consent'
                  );
                  let marketingConsentCheckbox = $(
                    '.marketing-consent-acceptance'
                  );
                  marketingConsentCheckbox.addClass(
                    'combined-marketing-consent-acceptance'
                  );
                  $('.combined-marketing-consent').addClass('scrollbar');

                  /*Terms and conditions css */
                  $('.terms_conditions__modal').addClass(
                    'combined-terms_conditions__modal'
                  );
                  $('.terms_conditions__state').addClass('scrollbar');
                  /* Code to append Error elements to top of the screen for combine consent */
                  $(
                    '.termsAndCondition_content .oktaErrorDiv,.termsAndCondition_content .customerExistDiv'
                  ).insertAfter('.registration_wrapper');
                  /*if (window.innerWidth > 768) {
                    $('.consent-cancel-link')
                      .removeClass('col-xs-5 pr-0')
                      .find('.termsAndCondition__Cancelbutton')
                      .addClass('col-xs-5');
                  } else {
                    $('.consent-cancel-link')
                      .addClass('col-xs-5 pr-0')
                      .find('.termsAndCondition__Cancelbutton')
                      .removeClass('col-xs-5');
                  }*/
                })
                .catch(() => {
                  openTermsAndConditionsAjaxFlag = true;
                });
            }
          });
        }
      })
      .catch(() => {
        validateStepTwoAjaxFlag = true;
      });
  }

  function openTermsAndConditions() {	
    var submitLeadUrl = null;
    if (location.pathname.indexOf('marketingconsent') > -1) {
      let marketingConsentVal = $('#marketingAccept').val();
      let marketingVersionVal = $('#marketingconsent-version-number').val(
        $('.marketing-consent-info .tc-pdf-version').text()
      );
      $('#consentField').val(marketingConsentVal);
      $('#versionField').val(marketingVersionVal.val());
      marketingFormSubmit = $(this).closest('#marketingSubmitform');
      marketingFormSubmit.submit();
    } else {
      if (location.pathname.indexOf('checkout') > -1) {
        submitLeadUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAccount.termsAndConditions}`;
      } else {
        submitLeadUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.patientMarketFlow.termsAndConditionUrl}`;
      }
      var currentForm = $('.step2_form').serialize();
      var prevForm = $(registerForm).serialize();
      var secondForm = $('.existingUser_generalInfo_form').serialize();    
      var termsAndConditionData = null;
      if (!openTermsAndConditionsAjaxFlag) return false;
      openTermsAndConditionsAjaxFlag = false;
      const formData = `${prevForm}&${currentForm}&${secondForm}`;
      formPostJsonResponse(submitLeadUrl, formData)
        .then(data => {
          openTermsAndConditionsAjaxFlag = true;
          termsAndConditionData = $.extend({}, data);
          if (location.pathname.indexOf('checkout') < 0) {
            ACC.colorbox
              .open('', {
                html: termsAndConditionData.termsAndConditions,
                onLoad: $('#cboxOverlay').css('position', 'fixed'),
                width: checkWidth(),
                height: checkHeight(),
                className: 'terms-popup'
              })
              .promise()
              .done(function() {
                openTermsAndConditionsAjaxFlag = true;
                appendPdfUrl($('.tc-pdf-download-url').text());
                /** OFF scroll event, in case when user close and open COLORBOX multiple time, then multiple scroll event should not bind **/
                $('#printDoc')
                  .off('scroll', enableTermAndConditionButton)
                  .on('scroll', enableTermAndConditionButton);
              });
          } else {
            $('.registration_wrapper').hide();
            $('.marketing_consent_inner').hide();
            $('.registration_container')
              .append(termsAndConditionData.termsAndConditions)
              .promise()
              .done(function() {
              if(isExistingUser){
                $('.termsAndCondition_newCheckoutUser_buttons').remove()
              }
              else{
                $('.termsAndCondition_buttons').remove()
              }
                openTermsAndConditionsAjaxFlag = true;
                appendPdfUrl($('.tc-pdf-download-url').text());
                /** OFF scroll event, in case when user close and open COLORBOX multiple time, then multiple scroll event should not bind **/
                $('#printDoc')
                  .off('scroll', enableTermAndConditionButton)
                  .on('scroll', enableTermAndConditionButton);
              });
            $('.terms_conditions__header').addClass(
              'terms_conditions__header_checkout'
            );
            $('.registration_container').show('fast', function() {
              $(window).scrollTop(0);
            });
          }
        })
        .catch(() => {
          openTermsAndConditionsAjaxFlag = true;
        });
    }
  }

  function appendPdfUrl(pdfUrl) {
    $('#pdf-version-number').val($('#printDoc .tc-pdf-version').text());
    $('.print-term-condtion').attr('href', decodeURIComponent(pdfUrl));
    $('.downloadPdf').attr(
      'href',
      decodeURIComponent(pdfUrl) + '/Terms-and-Conditions.pdf'
    );
  }

  function inValidInputFindFacility(e) {
    if (!e.target.validity.valid) {
      e.preventDefault();
      $(this)
        .next()
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function validateInputFindFacility(e) {
    e.preventDefault();
    $(this)
      .next()
      .next()
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');

    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .next()
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  var findFacilityInput = document.getElementsByClassName('findFacility_input');
  $.each(findFacilityInput, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInputFindFacility);
  });

  function resetInput() {
    formElement[0].reset();
    $('.passwordFieldValidation').removeClass('error-msg-textbox');
    $('.registerStep2_input').removeClass('error-msg-textbox');
    $('.findFacility_input').removeClass('error-msg-textbox');
    $('error-msg-text-step2').attr('hidden', true);
    $('.error-msg-text-state').attr('hidden', true);
    $('.error-msg-text-name').attr('hidden', true);
  }

  function enableTermAndConditionButton(e) {
    var totalHeight = $(this).scrollTop() + $(this).innerHeight();
    var scrollDiveHeight = $('.scrolldiv').height();
    if (totalHeight >= scrollDiveHeight) {
      $('.termsAndCondition__Savebutton').attr('disabled', false);
    }
  }

  function scrollDownTermAndCondition(e) {
    const printDoc = $('#printDoc');
    const scrollDiv = printDoc.find('.scrolldiv');
    printDoc.scrollTop(scrollDiv.height());
  }

  function resetRegisterStep2() {
    $('.step2_form').trigger('reset');
    var invalidFields = $('.step2_form').find('.error-msg-textbox');
    var errorMessages = $('.step2_form').find('.error-msg-text');

    _toConsumableArray(errorMessages).forEach(function(msg) {
      $(msg).attr('hidden', true);
    });

    _toConsumableArray(invalidFields).forEach(function(field) {
      $(field).removeClass('error-msg-textbox');
    });
  }

  function backFromPatientConsent() {
    $('.registration_wrapper').show();
    $('.patient_consent_inner').remove();
    $('.registration_wrapper').show('fast', function() {
      $(window).scrollTop(0);
    });
  }

  function validateInputField(e) {
    var regExp = new RegExp("^[a-zA-Z 0-9'-]+$");
    return restrictInvalidCharacters(e, regExp);
  }

  function validateTollFree() {
    let tollFreeCodesRegex = JSON.parse($('#tollFreeCodes').val()).join('|');
    var phoneRegex = new RegExp(
      '^((?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4})$'
    );
    if (!phoneRegex.test($(this).val()) && $(this).val().length == 12) {
      $(this)
        .addClass('error-msg-textbox')
        .parent()
        .find('.pattern-mismatch-toll-text')
        .attr('hidden', false);
      $(this)
        .parent()
        .find('.pattern-mismatch-text')
        .attr('hidden', true);
    } else if (phoneRegex.test($(this).val())) {
      $(this)
        .removeClass('error-msg-textbox')
        .parent()
        .find('.pattern-mismatch-toll-text')
        .attr('hidden', true);
    }
    if ($(this).val().length === 0 && !$(this).attr('required')) {
      $(this)
        .removeClass('error-msg-textbox')
        .parent()
        .find('.pattern-mismatch-toll-text')
        .attr('hidden', true);
    }
  }

  function validateConsentFields() {
    let errorFlag = true;
    const isPatient = $(radioPatient).is(':checked');
    const agreed = $(clsPatientAgree).prop('checked');
    if (agreed) {
      if (isPatient) {
        if ($(patientSignature).val().trim() === '') {
          errorFlag = false;
          $(patientSignature)
            .next()
            .removeClass(clsHidden);
          $(patientSignature).addClass(errorClass);
        }
      } else {
        if ($(patientSignature).val().trim() === '') {
          errorFlag = false;
          $(patientSignature)
            .next()
            .removeClass(clsHidden);
          $(patientSignature).addClass(errorClass);
        }
        if ($(patientRelationship).val() === '') {
          errorFlag = false;
          $(patientRelationship)
            .next()
            .removeClass(clsHidden);
          $(patientRelationship).addClass(errorClass);
        }
        if (
          $(reasonPatientId).val() === '' ||
          $(reasonPatientId).val() === null
        ) {
          errorFlag = false;
          $(patientReasonId)
            .next()
            .removeClass(clsHidden);
          $(patientReasonId).addClass(errorClass);
        }
        if ($(otherReasonsField).val() === '') {
          if ($(otherReasonsField).hasClass('validCommon')) {
            errorFlag = false;
            $(otherReasonsField)
              .next()
              .removeClass(clsHidden);
            $(otherReasonsField).addClass(errorClass);
          }
        }
      }
    }
    return errorFlag;
  }

  function validateInputCommon(e) {
    e.stopImmediatePropagation();
    $(this)
      .next()
      .addClass(clsHidden);
    $(this).removeClass(errorClass);
    if ($(this).val() === '') {
      $(this)
        .next()
        .removeClass(clsHidden);
      $(this).addClass(errorClass);
    }
  }

  function resendEmailActivation() {
    startCountDown();
    if(resendEmailActivationUrl != undefined){
      jsonGet(resendEmailActivationUrl+'&activationEmailSentTime='+new Date().toLocaleString()).then(response => {
        if (response === true || response === 'true') {
          $(this)
            .parents('#cboxLoadedContent')
            .find('.resent-email-success-msg')
            .removeClass('hidden');
          $('.email-notification-overlay-container:last').scrollTop(
            $(
              '.email-notification-overlay-container:last .resent-email-success-msg'
            ).offset().top
          );
          $.colorbox.resize();
        } else if (response.toLowerCase() === 'failure') {
          window.location.href = '/';
        }
      });
    }
  }

  function navigateToCreateSection() {
    let patientConsentCheckbox = $('.patientConsent_content_agree');
    $('.registration_wrapper').show();
    $('.patientConsent_content').append(patientConsentCheckbox);
    $('.combined-patient-consent').remove();
    $('.combined-marketing-consent').remove();
    $('.combined-terms_conditions__modal').remove();
    $('#marketingconsent-version-number').remove();
    $('#pdf-version-number').remove();
    $('.oktaErrorDiv,.customerExistDiv').remove();
    $('.registration-container__account').removeClass('combined-consent-style');
    $('.pre_registration_container').removeClass(
      'combined-preregister-consent-style'
    );
    $(window).scrollTop(0);
  }

  function checkPasswordFieldMatch(e) {
	e.preventDefault();
	$('.register-user').attr('disabled', true);
    if (confirmPasswordValidation() && validatePasswordComplexity() && location.pathname.indexOf('register/okta-activation-user') > -1) {
		//Form summittion logic with Okta error handling
		var formData = $('#chhOktaPasswordActivationForm').serialize();
        var formActionURL = $('#chhOktaPasswordActivationForm').attr('action');
        formPostJsonResponse(formActionURL, formData)
          .then(data => {
            	//success logic only for okta error
            	if(data !=undefined && data != null){
					if(data.error != undefined && data.error != null){
						//display toast msg here.
						$('.password-error-container').removeClass('hidden');
						$('.password-error-container').find('.password-error-msg-box').html(data.error);
						console.log("@@@@ "+data.error)
					}else if(data.REDIRECT != undefined && data.REDIRECT != null){
						window.location = data.REDIRECT;
					}
				}
           })
           .catch(() => {
                console.log("Error in form submission")
            });
      
    }else{
      return false;
	}
    
  }

  function validatePasswordComplexity(){
    let searchParams = new URLSearchParams(window.location.search);
    const pwd = $('#createNewPassword').val();
    const email = searchParams.get('emailId');
    const emailParts = email.split(/[#@.,_-]/);
    for(const part of emailParts){
      if(part.length > 3 && pwd.toLowerCase().includes(part)){
        $('.passwordField').addClass('error-msg-textbox');
        $('.confirmPasswordField').addClass('error-msg-textbox');
        $('.error-msg-password-invalid').attr('hidden', false);
        return false;
      }
    }
    return true;
  }

  function validateEmailComplexity(event){
    let inputName = $(event.currentTarget).attr('name');
	  let errorField = (inputName == 'email') ? '.emailtxtvalid' : '.confirmemailtxtvalid';
	  let flag = false;
	  const emailInput = $(this).val();
	  const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
	  if(emailInput !== ''){
	    if(emailPattern.test(emailInput)){
	      $(errorField).attr('hidden', true);
	      $(this).removeClass('error-msg-textbox');
	      flag = true;
	    }else{
	      $(errorField).attr('hidden', false);
	      $(this).addClass('error-msg-textbox');
	    }
	    if(inputName == 'email') emailFormatFlag = flag;
	    else if(inputName == 'confirmEmail') confirmEmailFormatFlag = flag;
	  }
  }

  function startCountDown(){
    var button= $('#colorbox').find('#resendEmailActivationBtn');
    button.attr('disabled', true);
    var countDownDuration = 29;
    var countDown = setInterval(function(){
      countDownDuration--;
      if(countDownDuration == 0){
        button.attr('disabled', false);
        clearInterval(countDown);
      }
    },1000);
  }
  
  function orderSummaryGuestCheckoutContinue(){
	  if(bOrderSummaryGuestCheckoutContinueFlag) return ;
	  bOrderSummaryGuestCheckoutContinueFlag = true;
	  const createUserUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAccount.createUser}`;
	  const userid = $('#uid-order-summary').val();
	  let formData = `userid=${userid}&isGuestUserActivation=true&activationToken=null`
	  htmlPost(createUserUrl, formData)
		.then(data => {
			let responseData = JSON.parse(data);
			if (responseData.STATUS === 'SUCCESS') {
				$.colorbox.close();
				setTimeout(function() {
					ACC.colorbox.open('', {
				        escKey: false,
				        overlayClose: false,
				        closeButton: false,
				        html: $('#email-notification-overlay').html(),
				        onLoad: $('#cboxOverlay').css('position', 'fixed'),
				        width:  checkWidthEmailOverlay(),
				        height: checkHeightEmailOverlay(),
				        className: 'email-notification-overlay-main'
				    });
				    startCountDown();
				    resendEmailActivationUrl = responseData.resendOktaActivationLink;
				    $('.oktaActivationTestLink').attr('href',responseData.oktaActivationTestLink);
				    bOrderSummaryGuestCheckoutContinueFlag = false;
				}, 500);
			}else{
				$('.oktaErrorDiv').attr('hidden', false);
			}
		})
		.catch(error => {
		    bOrderSummaryGuestCheckoutContinueFlag = false;
		});
  }

  $(document).on('submit', '.step2_form', validateStep2);
  if (flowType !== 'preRegister') {
    $('.registerField').on('keyup change', enableRegister);
  }
  $('.registerStep2_input').on('input', inValidFormInput);
  $('.findFacility_input').on('input', validateInputFindFacility);
  $('.back-to-search-link').on('click', backToRegistrationStep1);
   $('.close').on('click', resetModal);
  $('.newFacility_cancelBtn').on('click', resetModal);
  formElement.on('click', '.cancelBtn', resetInput);
  $(document).on('click', '.print-term-condtion', printTcDOc);
  $(document).on('click', '#patientConsentContinue', showMarketingConsent);
  $(document).on('click', '#marketingConsentContinue', showTermsandConditions);

  $(document).on(
    'click',
    '.termsAndCondition__Savebutton',
    saveTermsAndConditions
  );
  $('.existingUser_form').on('submit', existingUser);
  $('.existingUser_generalInfo_form').on('submit', existingUserGeneralPage);
  $(document).on('click', '.js-scrollDown', scrollDownTermAndCondition);
  $('.back-to-search').on('click', resetRegisterStep2);
  $(document).on(
    'click',
    '.marketing-consent-save-btn',
    openTermsAndConditions
  );

  $(document).on(
    'keypress',
    '.registration-form-section #firstName, .registration-form-section #lastName, .existingUser_lastname',
    validateInputField
  );
  $(document).on('selectmenucreate', 'select', initializeSelectMenuCreation);
  $(document).on('selectmenuchange', 'select', selectmenuChangeHandler);
  $(document).on('click', patientCancelBtn, backFromPatientConsent);
  $(document).on(
    'click blur keyup selectmenuchange',
    '.required-val',
    enableNextButtonFunction
    );
    
  $(document).on('input change', '.new-account-phone', validateTollFree);
  $(document).on('input', requiredFieldCommon, validateInputCommon);
  $(document).on('click', '.notification-overlay-btn', resendEmailActivation);
  $(document).on('click', '.btn-guestCheckout-continue', orderSummaryGuestCheckoutContinue);
  $(document).on(
    'click',
    '.termsAndCondition__Backbutton ,.combinedPatientBack',
    navigateToCreateSection
  );
  $(document).on(
    'submit',
    '#chhOktaPasswordActivationForm',
    checkPasswordFieldMatch
  );
  $(document).on('keyup', '.registration--form-dob', ACC.utility.formatDateInputField);
  if (location.pathname.indexOf('checkout') == -1 && location.pathname.indexOf('my-account-home') == -1) {
    $(document).on('click','.opt-in-out', enableNextButtonFunction);
    $(document).on('blur','#phone-no-sms-enroll', enableNextButtonFunction);
  }
  function createTooltipContent() {
    toolTipBodyPwdText = toolTipBodyPwdText || '';
    let numberOfOptions = toolTipBodyPwdText.split(';');
    let txt1 = `<div class="text-left">${toolTipHeaderPwdText}</div>`;
    let txt3 = `<div class="text-left pt-2">${toolTipFooterPwdText}</div>`;
    let txt2 = '<ul>';
    $.each(numberOfOptions, function(index, value) {
      txt2 += '<li>' + value + '</li>';
    });
    txt2 += '</ul>';
    tooltipContent = txt1 + txt2 + txt3;
    $('.common-password-layout')
      .find('.tooltiptext')
      .html(tooltipContent);
  }
  if (toolTipBodyPwdText != undefined) {
    createTooltipContent();
  }

  function showRGHforExistingAccountModal(){
    ACC.colorbox.open('', {
      escKey: false,
      overlayClose: false,
      closeButton: false,
      html: $('#rgh-for-Existing-Account-modal').html(),
      onLoad: $('#cboxOverlay').css('position', 'fixed'),
      width: '340px',
      className: 'rgh-for-Existing-Account-modal'
    });
    $('#colorbox').find('#continueEdgeparkBtn').off('click').on('click', function(){
        window.open(`${API_REFERENCE.newRegistration.edgeparkUrl}`,'_self');
      })
    
  }

  function getFormData($form){
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};        
    $.map(unindexed_array, function(n, i){
      indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }

});
